import React, { useContext, useCallback, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { TimelineContext } from '../../../../../../contexts/TimelineContext'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'
import { ChevronUp } from 'react-bootstrap-icons'
import AssetListItem from './AssetListItem'
import { groupTimelineScenarioAssets } from '../../../../../../utils/groupTimelineScenarioAssets'

const groupShellClassName =
  'mb-3 overflow-hidden rounded-xl bg-rb-surface-muted px-3 py-3 dark:bg-rb-dark-mode-lighter/50'
const groupHeaderClassName =
  'flex w-full items-center justify-between px-1 text-left'
const groupToggleIconClassName =
  'ml-2 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-rb-widget-border bg-white text-rb-black shadow-sm dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:text-white'

function ScenarioAssetInfluencerGroup({ group, onSelectAction }) {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <section className={groupShellClassName}>
      <button
        type="button"
        onClick={() => setIsOpen((current) => !current)}
        className={groupHeaderClassName}
        aria-expanded={isOpen}
      >
        <h3 className="min-w-0 truncate text-sm font-semibold leading-6 text-rb-black dark:text-white">
          {group.name}
        </h3>
        <span className={groupToggleIconClassName}>
          <ChevronUp className={`text-xs transition-transform ${isOpen ? '' : 'rotate-180'}`} />
        </span>
      </button>

      {isOpen && (
        <div className="mt-3">
          {group.assets.map((asset) => (
            <AssetListItem
              key={`asset-${asset.id}`}
              asset={asset}
              onClick={() => onSelectAction(asset)}
              grouped
            />
          ))}
        </div>
      )}
    </section>
  )
}

export default observer(function ScenarioAssets() {
  const { actions, setJumpToDate, clearJumpToDate } = useContext(TimelineContext)
  const { campaign } = useContext(SharedCampaignContext)
  const groupedActions = groupTimelineScenarioAssets(actions || [])

  const handleSelectAction = useCallback(
    (action) => {
      const target = action.start_date || campaign?.start_date || null
      if (!target) return
      clearJumpToDate()
      requestAnimationFrame(() => setJumpToDate({ start_date: target }))
    },
    [campaign?.start_date, setJumpToDate, clearJumpToDate],
  )

  return (
    <div className="mt-5 w-full">
      <div className="flex items-center justify-between">
        <h2 className="font-bold text-base dark:text-white">Scenario Assets</h2>
        <span className="text-rb-lighter-grey dark:text-gray-400">{actions?.length}</span>
      </div>

      <div className="mt-3 min-h-[50px]">
        {groupedActions.map((group) => (
          <ScenarioAssetInfluencerGroup
            key={group.key}
            group={group}
            onSelectAction={handleSelectAction}
          />
        ))}
      </div>
    </div>
  )
})
